<template>
    <v-expansion-panels
        v-model="isOpenState"
        class="rtls-expansion-panels attribute-filter-panel"
        tile
    >
        <v-expansion-panel focusable class="rtls-expansion-panel mb-4">
            <v-expansion-panel-title class="panel-header">
                <div class="body-2">
                    <span class="filter-text-title">
                        {{ $tkey('title') }}
                    </span>
                    <v-icon v-once class="filter-text">
                        mdi-filter-variant
                    </v-icon>
                    <span class="font-weight-bold filter-text">
                        {{ $tkey('numberOfProducts') }}
                        <template v-if="!getProductsInProgress">
                            {{ productsNumberInPromotion }}
                        </template>
                        <template v-else>
                            <spinner-dynamic class="pt-1" />
                        </template>
                    </span>
                    <div
                        v-if="showOverwlowError"
                        class="attribute-filter-panel__max-products-error"
                    >
                        <span class="error--text">
                            {{ $tkey('maxProductsNumberError', { maxAllowedProductCount }) }}
                        </span>
                    </div>
                </div>
                <template #actions>
                    <v-icon
                        :class="[
                            'attribute-filter-panel__toggle-icon',
                            { 'attribute-filter-panel__toggle-icon--open': isOpenState !== 0 },
                        ]"
                        color="indigo darken-2"
                    >
                        custom:expand_less
                    </v-icon>
                </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text class="panel-header">
                <v-card-text class="px-6 pt-3">
                    <template v-if="isMultipleAttributeSegmentsEnabled">
                        <p class="attribute-filter-panel__segments-description">
                            {{ $tkey('segmentsDescription') }}
                        </p>
                        <template
                            v-for="(segment, segmentIndex) in attributeSegments"
                            :key="segment.id"
                        >
                            <attribute-filter-segment
                                :segment="segment"
                                :segment-index="segmentIndex"
                                :segment-count="attributeSegments.length"
                                :available-attribute-keys-by-row-key="
                                    attributeFilterAttributeKeysByRowKey
                                "
                                :available-values-by-row-key="attributeFilterValueOptionsByRowKey"
                                :add-condition-disabled="isAddConditionDisabled(segment)"
                                @add-condition="addAttributeRow"
                                @remove-condition="onRemoveAttributeRow"
                                @remove-segment="removeSegment"
                                @products-number-updated="debouncedOnProductsNumberUpdated"
                            />
                            <div
                                v-if="segmentIndex < attributeSegments.length - 1"
                                :key="`OrDivider::${segment.id}`"
                                class="attribute-filter-panel__or-divider"
                            >
                                <v-divider />
                                <span>{{ $tkey('orDivider') }}</span>
                                <v-divider />
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <v-col
                            v-for="attributeRow in activeAttributesCount"
                            :key="attributeScope[attributeRow - 1].key"
                            cols="12"
                            class="pa-0"
                        >
                            <attribute-filter
                                :key="`Filter::${attributeScope[attributeRow - 1].key}`"
                                :attribute-row-index="attributeRow - 1"
                                :attribute-scope="stagingAreaPromotion.attributeScope"
                                :available-attribute-keys="
                                    attributeFilterAttributeKeysByRowKey[
                                        attributeScope[attributeRow - 1].key
                                    ] || []
                                "
                                :available-values="
                                    attributeFilterValueOptionsByRowKey[
                                        attributeScope[attributeRow - 1].key
                                    ] || []
                                "
                                :validate-attribute-select="activeAttributesCount > 1"
                                @remove-attribute-row="onRemoveAttributeRow"
                                @products-number-updated="
                                    debouncedOnProductsNumberUpdated({ markDirty: true })
                                "
                            />
                            <v-divider :key="`Divider::${attributeRow}`" class="my-2" />
                        </v-col>
                    </template>

                    <!-- Button to add an additional filter rule -->
                    <div class="attribute-filter-panel__actions">
                        <v-btn
                            v-if="!isMultipleAttributeSegmentsEnabled"
                            :disabled="addButtonDisabled"
                            density="compact"
                            elevation="0"
                            icon
                            @click="addAttributeRow"
                        >
                            <v-icon v-once color="indigo darken-2">custom:add_box</v-icon>
                        </v-btn>
                        <v-btn
                            v-else
                            :disabled="addSegmentDisabled"
                            density="compact"
                            elevation="0"
                            variant="text"
                            color="primary"
                            prepend-icon="custom:add_box"
                            @click="addSegment"
                        >
                            {{ $tkey('addProductGroup') }}
                        </v-btn>
                        <!--There is desicion to not use these buttons-->
                        <!--If decision would change uncomment below code-->

                        <div class="attribute-filter-panel__actions--confirmation">
                            <!-- <confirm-dialog
                                class="confirm-dialog"
                                :question-text="$tkey('revertQuestionText')"
                                :warning-text="$tkey('revertWarningText')"
                                :action-text="$tkey('revertActionText')"
                                @confirm="revertAttributeScope"
                            >
                                <template v-slot:actions="{ activator }">
                                    <v-btn
                                        v-bind="activator"
                                        :disabled="isAttributeScopeUnchanged || saveInProgress"
                                        text
                                        primary
                                        small
                                    >
                                        {{ $tkey('revertActionText') }}
                                    </v-btn>
                                </template>
                            </confirm-dialog>
                            <confirm-dialog
                                v-if="!isSavingInProgress"
                                ref="saveDialog"
                                class="confirm-dialog"
                                :question-text="$tkey('saveQuestionText')"
                                :warning-text="
                                    $tkey('saveWarningText', { productsNumberInPromotion })
                                "
                                :action-text="$tkey('saveActionText')"
                                @confirm="saveProductsToAttributeScopePromotion"
                            >
                                <template v-slot:actions>
                                    <positive-action-button
                                        v-if="!isSavingInProgress"
                                        :disabled="saveDialogDisabled"
                                        @onClick="openSaveDialog"
                                    >
                                        {{ $tkey('saveActionText') }}
                                    </positive-action-button>
                                </template>
                            </confirm-dialog> -->
                            <spinner-dynamic v-if="isSavingInProgress" class="pt-2" />
                        </div>
                    </div>
                </v-card-text>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import { cloneDeep, get, isNil } from 'lodash';
import {
    addAttributeRow as addAttributeRowUtil,
    addSegment as addSegmentUtil,
    initializeAttributeFilterState,
    onRemoveAttributeRow as onRemoveAttributeRowUtil,
    onProductsNumberUpdated as onProductsNumberUpdatedUtil,
    createDebouncedOnProductsNumberUpdated,
    removeSegment as removeSegmentUtil,
    revertAttributeScope as revertAttributeScopeUtil,
} from '@/js/pages/planning/utils/attribute-filter-panel-utils';

export default {
    localizationKey: 'planning.promotionsViewer.attributeScopePromotion',
    props: {
        stagingAreaPromotion: {
            type: Object,
            required: true,
        },
        namespace: {
            type: String,
            required: true,
        },
        productOfferGroupId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            productsNumberInPromotion: 0,
            cacheAttributeScope: null,
            cacheAttributeSegments: null,
            attributeFilterAttributeKeysByRowKey: {},
            attributeFilterValueOptionsByRowKey: {},
            userInteraction: false,
            isSavingInProgress: false,
            isOpenState: 0,
            getProductsInProgress: false,
            getProductsRequestId: null,
        };
    },
    computed: {
        ...mapState('clientConfig', ['generalConfig', 'toggleLogic']),
        ...mapState('promotions', ['tabValidationState', 'saveInProgress']),
        ...mapGetters('attributeMetadata', ['getAvailableAttributes']),
        activeAttributesCount() {
            return this.attributeScope.length;
        },
        attributeScope() {
            return this.stagingAreaPromotion.attributeScope || [];
        },
        attributeSegments() {
            return this.stagingAreaPromotion.attributeSegments || [];
        },
        isMultipleAttributeSegmentsEnabled() {
            return get(this.toggleLogic, 'enableMultipleAttributeSegments', false);
        },
        numFiltersApplied() {
            if (this.isMultipleAttributeSegmentsEnabled) {
                return this.attributeSegments.reduce(
                    (count, segment) =>
                        count + (segment.rows || []).filter(attr => attr.attributeKey).length,
                    0
                );
            }

            return this.attributeScope.filter(attr => attr.attributeKey).length;
        },
        selectedCategoryKeys() {
            return (this.stagingAreaPromotion.userSelectedCategories || [])
                .map(category => {
                    if (category && typeof category === 'object') {
                        return category.levelEntryKey;
                    }

                    return category;
                })

                .filter(category => !isNil(category));
        },
        addButtonDisabled() {
            return (
                this.getAvailableAttributes.length === this.attributeScope.length ||
                this.attributeScope.length === this.maxAttributesNumber ||
                this.isReadOnly
            );
        },
        maxAttributeSegmentsNumber() {
            return this.generalConfig.maxAttributeSegmentsPerPromotion || 5;
        },
        addSegmentDisabled() {
            return (
                this.attributeSegments.length >= this.maxAttributeSegmentsNumber || this.isReadOnly
            );
        },
        showOverwlowError() {
            return (
                this.numFiltersApplied > 0 &&
                this.productsNumberInPromotion > this.maxAllowedProductCount
            );
        },
        saveDialogDisabled() {
            return !this.isValid || this.showOverwlowError || this.getProductsInProgress;
        },
        isValid() {
            if (!this.stagingAreaPromotion) {
                return false;
            }
            const tabsValid =
                this.tabValidationState.channels === 'completed' &&
                this.tabValidationState.date === 'completed';
            // global promotion conditions
            if ((!tabsValid && this.namespace === 'default') || this.saveInProgress) {
                return false;
            }

            if (this.isMultipleAttributeSegmentsEnabled) {
                if (
                    this.attributeSegments.length === 1 &&
                    this.attributeSegments[0].rows.length === 1 &&
                    this.attributeSegments[0].rows[0].attributeKey === null
                ) {
                    return true;
                }

                return this.attributeSegments.every(segment =>
                    this.areAttributeRowsValid(segment.rows || [])
                );
            }

            // local state conditions
            if (
                this.stagingAreaPromotion.attributeScope.length === 1 &&
                this.stagingAreaPromotion.attributeScope[0].attributeKey === null
            ) {
                return true;
            }
            return this.areAttributeRowsValid(this.stagingAreaPromotion.attributeScope);
        },
        maxAttributesNumber() {
            return this.generalConfig.maxAttributesPerPromotion;
        },
        maxAllowedProductCount() {
            return this.generalConfig.maxProductsPerPromotion;
        },
        isDynamicAttributeFilteringEnabled() {
            return get(this.toggleLogic, 'useDynamicAttributeFiltering', false);
        },
        showRemoveAllProductsMessage() {
            return this.productsNumberInPromotion === 0 && this.userInteraction;
        },
        /**
         * Determines whether the attribute scope remains unchanged between two given scopes.
         * Compares the provided previous and current attribute scopes to check if they are equivalent,
         * indicating that no changes have occurred in the attribute scope context.
         *
         * @returns {boolean} Returns true if the attribute scopes are unchanged; otherwise, false.
         */
        isAttributeScopeUnchanged() {
            if (!this.cacheAttributeScope || !this.attributeScope) return false;

            if (this.isMultipleAttributeSegmentsEnabled) {
                return (
                    JSON.stringify(this.attributeSegments) ===
                    JSON.stringify(this.cacheAttributeSegments)
                );
            }

            return JSON.stringify(this.attributeScope) === JSON.stringify(this.cacheAttributeScope);
        },
    },
    watch: {
        saveDialogDisabled(newValue) {
            this.setAttributeFilterValidation({
                namespace: this.namespace,
                value: !newValue,
            });
        },
        selectedCategoryKeys(newCategories, oldCategories) {
            if (JSON.stringify(newCategories) === JSON.stringify(oldCategories)) {
                return;
            }

            this.debouncedOnProductsNumberUpdated();
        },
    },
    mounted() {
        initializeAttributeFilterState(this);

        // This ensures that modifications to 'cacheAttributeScope' do not affect the original 'attributeScope' object.
        // cacheAttributeScope is used to revert changes if needed.
        this.cacheAttributeScope = cloneDeep(this.stagingAreaPromotion.attributeScope);
        this.cacheAttributeSegments = cloneDeep(this.stagingAreaPromotion.attributeSegments || []);

        if (this.selectedCategoryKeys.length) {
            this.debouncedOnProductsNumberUpdated();
        } else {
            this.productsNumberInPromotion = this.stagingAreaPromotion.products.length;
        }

        this.emitter.on(
            'forecast-and-save-attribute-scoped-promotion',
            this.onForecastAndSaveAttributeScopedPromotion
        );
    },
    beforeUnmount() {
        this.emitter.off(
            'forecast-and-save-attribute-scoped-promotion',
            this.onForecastAndSaveAttributeScopedPromotion
        );
    },
    methods: {
        ...mapActions('products', [
            'fetchPromotionAttributeFilterOptions',
            'applyPromotionAttributeFilterResponse',
        ]),
        ...mapActions('promotions', ['saveAttributeScopePromotion']),
        ...mapMutations('promotions', ['setUnsavedPromotion', 'setAttributeFilterValidation']),
        prepareAttributeScopeRowsForRequest() {
            if (this.isMultipleAttributeSegmentsEnabled) {
                return cloneDeep(this.attributeSegments);
            }

            return cloneDeep(this.stagingAreaPromotion.attributeScope || []);
        },
        areAttributeRowsValid(rows) {
            return rows.every(attr => {
                if (!attr.attributeKey) {
                    return false;
                }

                if (attr.rangeOperator === 'gte') {
                    return !isNil(attr.minValue);
                }

                if (attr.rangeOperator === 'lte') {
                    return !isNil(attr.maxValue);
                }

                if (attr.rangeOperator === 'between') {
                    return (
                        !isNil(attr.minValue) &&
                        !isNil(attr.maxValue) &&
                        Number(attr.minValue) <= Number(attr.maxValue)
                    );
                }

                return attr.values.length > 0;
            });
        },
        isAddConditionDisabled(segment) {
            return (
                this.getAvailableAttributes.length === (segment.rows || []).length ||
                (segment.rows || []).length === this.maxAttributesNumber ||
                this.isReadOnly
            );
        },
        addAttributeRow(segmentIndex = null) {
            addAttributeRowUtil(this, { segmentIndex });
        },
        addSegment() {
            addSegmentUtil(this);
        },
        removeSegment(segmentIndex) {
            removeSegmentUtil(this, segmentIndex);
        },
        onRemoveAttributeRow(event) {
            onRemoveAttributeRowUtil(this, event);
        },
        async onProductsNumberUpdated({ markDirty = false } = {}) {
            await onProductsNumberUpdatedUtil(this, {
                markDirty,
                orderedSelections: this.prepareAttributeScopeRowsForRequest(),
            });
        },
        debouncedOnProductsNumberUpdated: createDebouncedOnProductsNumberUpdated(
            async (context, options = {}) => {
                await onProductsNumberUpdatedUtil(context, {
                    ...options,
                    orderedSelections: context.prepareAttributeScopeRowsForRequest(),
                });
            }
        ),
        revertAttributeScope() {
            revertAttributeScopeUtil(this);
        },
        syncAttributeScopeFromFirstSegment() {
            if (!this.isMultipleAttributeSegmentsEnabled || !this.attributeSegments.length) {
                return;
            }

            this.stagingAreaPromotion.attributeScope = cloneDeep(
                this.attributeSegments[0].rows || []
            );
        },
        async saveProductsToAttributeScopePromotion() {
            this.isSavingInProgress = true;
            try {
                this.syncAttributeScopeFromFirstSegment();
                await this.saveAttributeScopePromotion({
                    namespace: this.namespace,
                    attributeScope: this.stagingAreaPromotion.attributeScope,
                    attributeSegments: this.stagingAreaPromotion.attributeSegments,
                    categories: this.stagingAreaPromotion.userSelectedCategories,
                    productOfferGroupId: this.productOfferGroupId,
                });
                this.cacheAttributeScope = cloneDeep(this.stagingAreaPromotion.attributeScope);
                this.cacheAttributeSegments = cloneDeep(
                    this.stagingAreaPromotion.attributeSegments || []
                );
                this.userInteraction = false;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error saving attribute scope promotion:', error);
            }
            this.isSavingInProgress = false;
        },
        openSaveDialog() {
            this.$refs.saveDialog.open();
        },
        async onForecastAndSaveAttributeScopedPromotion() {
            await this.saveProductsToAttributeScopePromotion();
        },
        resetAttributesScopeProducts() {
            if (this.selectedCategoryKeys.length) {
                this.debouncedOnProductsNumberUpdated({ markDirty: true });
                this.userInteraction = true;
                this.setUnsavedPromotion({ namespace: this.namespace, tab: 'offer', value: true });
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';

.attribute-filter-panel {
    &__max-products-error {
        padding-top: 0.3rem;

        .error--text {
            font-size: 1.2rem;
            color: $vuetify-error-red;
        }
    }

    .panel-header {
        background-color: $rtls-border-colour !important;
        min-height: 7rem !important;
        border-bottom: 0.1rem solid rgba(208, 208, 208, 0.87);

        :deep(.v-label),
        :deep(.v-chip__content) {
            font-size: 1.2rem;
        }
    }

    .filter-text {
        color: $promo-text-colour-2;
        font-size: 1.25rem;
    }

    .filter-text-title {
        font-size: 1.25rem;
    }

    &__actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 60%;
        padding-top: 1rem;

        .v-btn--disabled {
            color: rgba(var(--v-theme-on-surface), 0.26) !important;
        }
        :deep(.v-btn--icon .v-icon) {
            font-size: 1.6rem !important;
            width: 1.6rem !important;
            height: 1.6rem !important;
        }
    }

    &__segments-description {
        color: $promo-text-colour-2;
        font-size: 1.2rem;
        margin-bottom: 0.8rem;
    }

    &__or-divider {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
        gap: 1rem;
        color: $promo-text-colour-2;
        font-size: 1.1rem;
        font-weight: 700;
        letter-spacing: 0;
        margin: 0.4rem 0 0.8rem;
    }

    &__toggle-icon {
        transition: transform 0.2s ease;

        &--open {
            transform: rotate(180deg);
        }
    }

    :deep(.v-input) {
        .v-input__control {
            background: $promo-white;
        }
    }

    :deep(.v-expansion-panel-title__overlay) {
        opacity: 0;
    }
}
</style>
